// extracted by mini-css-extract-plugin
export var modal = "_mh-0";